import type { CustomerSession } from './customerSessionTypes.js';

export type CustomerSessionApplySource =
  | 'auth'
  | 'bootstrap'
  | 'cookie-refresh'
  | 'cross-tab-login';

/**
 * Resolve which session should win when hydration and explicit sign-in disagree.
 */
export function resolveCustomerSessionUpdate(
  current: CustomerSession | null,
  incoming: CustomerSession | null,
  source: CustomerSessionApplySource,
  hasExplicitAuthInTab: boolean,
): CustomerSession | null {
  if (incoming === null) {
    // G3 — null hydrate forces clear; never keep phantom session.
    return null;
  }
  if (current === null) {
    return incoming;
  }
  if (current.customerId === incoming.customerId) {
    // Stable identity — no-op merges must not reset timer effect deps (G14).
    return current;
  }
  if (source === 'auth' || source === 'cross-tab-login') {
    return incoming;
  }
  if (hasExplicitAuthInTab) {
    return current;
  }
  return incoming;
}
